<template>
  <header class="h-16 flex items-center justify-between px-6 bg-[#09090B] relative z-50">
    <!-- Left: Logo and Title -->
    <div class="flex items-center gap-3">
      <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center shadow-lg shadow-blue-500/30">
        <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
        </svg>
      </div>
      <div class="flex flex-col">
        <h1 class="text-white font-bold text-base tracking-tight">AI辅助科研项目管理系统</h1>
        <span class="text-xs text-slate-400">AI-Powered Research Project Management</span>
      </div>
    </div>

    <!-- Center: Navigation -->
    <nav class="flex items-center gap-1 bg-white/5 rounded-xl p-1 backdrop-blur-sm">
      <!-- 态势感知 -->
      <router-link to="/" class="nav-pill relative px-4 py-2 rounded-lg flex items-center gap-2" exact-active-class="is-active">
        <span class="nav-indicator"></span>
        <svg class="w-4 h-4" :class="$route.path === '/' ? 'text-blue-400' : 'text-slate-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
        </svg>
        <span class="nav-text text-sm font-medium" :class="$route.path === '/' ? 'text-blue-400' : 'text-slate-300'">态势感知</span>
      </router-link>

      <!-- 智能体助手 - 新增 -->
      <router-link to="/ai-assistant" class="nav-pill relative px-4 py-2 rounded-lg flex items-center gap-2" active-class="is-active">
        <span class="nav-indicator"></span>
        <svg class="w-4 h-4" :class="$route.path.includes('/ai-assistant') ? 'text-purple-400' : 'text-slate-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
        </svg>
        <span class="nav-text text-sm font-medium" :class="$route.path.includes('/ai-assistant') ? 'text-purple-400' : 'text-slate-300'">智能体助手</span>
        <span class="px-1.5 py-0.5 bg-purple-500/20 text-purple-400 rounded text-[10px] font-bold">AI</span>
      </router-link>

      <!-- AI智能评审 -->
      <router-link to="/review-center" class="nav-pill relative px-4 py-2 rounded-lg flex items-center gap-2" active-class="is-active">
        <span class="nav-indicator"></span>
        <svg class="w-4 h-4" :class="$route.path.includes('/review') || $route.path.includes('/guide') || $route.path.includes('/declare') || $route.path.includes('/consistency') || $route.path.includes('/research') || $route.path.includes('/expert') || $route.path.includes('/process-check') || $route.path.includes('/final') ? 'text-blue-400' : 'text-slate-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span class="nav-text text-sm font-medium" :class="$route.path.includes('/review') || $route.path.includes('/guide') || $route.path.includes('/declare') || $route.path.includes('/consistency') || $route.path.includes('/research') || $route.path.includes('/expert') || $route.path.includes('/process-check') || $route.path.includes('/final') ? 'text-blue-400' : 'text-slate-300'">AI智能评审</span>
      </router-link>

      <!-- 项目流程管理 -->
      <router-link to="/project-list" class="nav-pill relative px-4 py-2 rounded-lg flex items-center gap-2" active-class="is-active">
        <span class="nav-indicator"></span>
        <svg class="w-4 h-4" :class="$route.path.includes('/project') && !$route.path.includes('/project-review') ? 'text-emerald-400' : 'text-slate-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
        </svg>
        <span class="nav-text text-sm font-medium" :class="$route.path.includes('/project') && !$route.path.includes('/project-review') ? 'text-emerald-400' : 'text-slate-300'">项目流程管理</span>
      </router-link>

      <!-- 项目数据管理 -->
      <router-link to="/knowledge-base" class="nav-pill relative px-4 py-2 rounded-lg flex items-center gap-2" active-class="is-active">
        <span class="nav-indicator"></span>
        <svg class="w-4 h-4" :class="$route.path.includes('/knowledge') ? 'text-amber-400' : 'text-slate-400'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
        </svg>
        <span class="nav-text text-sm font-medium" :class="$route.path.includes('/knowledge') ? 'text-amber-400' : 'text-slate-300'">项目数据管理</span>
      </router-link>
    </nav>

    <!-- Right: User info -->
    <div class="flex items-center gap-3">
      <button class="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors">
        <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
        </svg>
      </button>
      <div class="flex items-center gap-2 pl-3 border-l border-white/10">
        <div class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center text-white font-bold text-xs">
          管
        </div>
        <div class="flex flex-col">
          <span class="text-sm font-medium text-white">管理员</span>
          <span class="text-xs text-slate-400">admin@system.com</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style scoped>
.nav-pill {
  position: relative;
  transition: all 0.3s ease;
}

.nav-pill:hover {
  background: rgba(255, 255, 255, 0.05);
}

.nav-pill.is-active {
  background: rgba(59, 130, 246, 0.15);
}

.nav-indicator {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #3b82f6;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.nav-pill.is-active .nav-indicator {
  opacity: 1;
}
</style>
